import { Table } from './Table';

export class LayoutViewModel {

    public sourceWidth: number = 300;
    public sourceHeight: number = 200;
    public sourceUrl: string = "";

    public width: number = 100;
    public get height(): number {
        return this.width * (this.sourceHeight / this.sourceWidth);
    };

    constructor(private collection: any) { }

    public get models(): Table[] {
        return this.collection.models;
    }

    public get items(): any[] {

        const clamp = (x: any) => {
            let r = x;
            if (x < 0) { r = 0 };
            if (x > 100) {
                r = 100;
            }
            return r / 100.0;
        }
        const width = this.width;
        const height = this.height;

        return this.models.map(m => {
            return ({
                model: m,
                x: clamp(m.layout_x) * width,
                y: clamp(m.layout_y) * height,
                seats: m.seats
            });
        })
    }
}